// extracted by mini-css-extract-plugin
export var answer = "bH_hj";
export var arrow = "bH_9";
export var body = "bH_c";
export var category = "bH_cK";
export var contactIcons = "bH_hb";
export var current = "bH_ft";
export var fade = "bH_hf";
export var footer = "bH_cx";
export var footerText = "bH_cy";
export var icon = "bH_bv";
export var iconContainer = "bH_b3";
export var issue = "bH_hh";
export var issueContainer = "bH_hd";
export var issueText = "bH_hg";
export var issues = "bH_hc";
export var left = "bH_bL";
export var padding = "bH_dL";
export var right = "bH_bX";
export var section = "bH_d";
export var selectors = "bH_dR";
export var subtitle = "bH_cV";
export var title = "bH_h";